import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiRepository } from '../../../../shared/infrastructure/api.repository';
import { AuthRepositoryPort } from '../../domain/repositories/auth.repository.port';
import { AuthSession } from '../../domain/entities/auth-session.entity';
import { AuthMapper, AuthApiResponse } from '../mappers/auth.mapper';

@Injectable()
export class AuthRepository extends ApiRepository implements AuthRepositoryPort {
  login(username: string, password: string): Observable<AuthSession> {
    return this.post<AuthApiResponse, { username: string; password: string }>(
      '/auth/Login',
      { username, password },
    ).pipe(map((r) => AuthMapper.toDomain(r)));
  }

  refreshToken(accessToken: string, refreshToken: string): Observable<AuthSession> {
    return this.post<AuthApiResponse, { accessToken: string; refreshToken: string }>(
      '/auth/RefreshToken',
      { accessToken, refreshToken },
    ).pipe(map((r) => AuthMapper.toDomain(r)));
  }

  logout(): Observable<void> {
    return this.post<void, Record<string, never>>('/auth/Logout', {});
  }
}
